import { locizeProjectId, locizeVersion } from "@/Configs/config";

import { initReactI18next } from "react-i18next";

import i18n from "i18next";
import Backend from "i18next-locize-backend";

export const languageIntlFormats: { [k: string]: string } = {
  en: "en-US",
  nb: "nb-NO",
};

const localStorageLanguage =
  typeof window !== "undefined" &&
  typeof window.localStorage?.getItem === "function"
    ? window.localStorage.getItem("language.preference")
    : null;
const browserLanguage =
  localStorageLanguage ||
  (["nn-NO", "nb-NO", "nb"].includes(navigator.language) ? "nb" : "en");

const locizeOptions = {
  projectId: locizeProjectId,
  version: locizeVersion,
  cdnType: "pro",
};

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: browserLanguage,
    fallbackLng: "en",
    backend: locizeOptions,
    react: {
      useSuspense: false,
    },
    interpolation: { escapeValue: false },
    ns: [
      "languages",
      "common",
      "entities",
      "actions",
      "hints",
      "errors",
      "periods",
      "eventTypes",
      "status",
      "systemMessages",
      "library",
      // label categories
      "statisticsLabels",
      "genericLabels",
      "drawerLabels",
      "formLabels",
      "filterLabels",
      "sidebarLabels",
      "configLabels",
      "historyLabels",
      "circularityLabels",
      "exportLabels",
      "importLabels",
      "propertyLabels",
      "rejectReasons",
      // v2 per page
      "homePage",
      "datePicker",
      "portfolioPage",
      "contaminationPage",
      "libraryPage",
      "reportingPage",
    ],
  });

export default i18n;
